import { api } from '../../../lib/api';
import { detalleError } from './contexto';

/**
 * Aurora IA en el editor de formularios. Una sola puerta: `POST /forms/{id}/aurora` con la acción
 * (ver email/claude/formularios.md). El backend NO guarda nada: devuelve lo que propone y el editor
 * lo aplica como cualquier otra edición, así que se puede deshacer.
 */
export function pedirAurora(formId, cuerpo) {
  // Pensar un formulario entero tarda: el mismo margen que usa la creación con IA
  return api.post(`/forms/${formId}/aurora`, cuerpo, { timeout: 180000 }).then((r) => r.data);
}

export const errorAurora = (err, defecto = 'Aurora IA no pudo responder') => detalleError(err, defecto);
